// extracted by mini-css-extract-plugin
export default {"container":"SkeletonItem-container-pk2","item":"SkeletonItem-item-GY9","image":"SkeletonItem-image-otU","info":"SkeletonItem-info-f_9","footer":"SkeletonItem-footer-xJc"};